import AppProvider from "context/AppContext";
import { default as SignUp } from "pages/SignUp";
import QuestionnaireFlow from "pages/QuestionnaireFlow";
import { BrowserRouter, Outlet, Route, Routes } from "react-router-dom";
import { ThemeProvider } from "x-wings";

function GlobalLoaderWrapper() {
	return (
		<AppProvider>
			<ThemeProvider>
				<Outlet />
			</ThemeProvider>
		</AppProvider>
	);
}

function App() {
	return (
		<BrowserRouter>
			<Routes>
				<Route path="/questionnaire/*" element={<GlobalLoaderWrapper />}>
					<Route path=":orderId/signup" element={<SignUp />} />
					<Route path=":orderId" element={<QuestionnaireFlow />} />
				</Route>
				<Route path="*" element={"Page not found! Please contact your travel agent"} />
			</Routes>
		</BrowserRouter>
	);
}

export default App;
